import React from "react";
import "./step-indicator.css";
import {useTranslation} from 'react-i18next'

/**
 * Props to use when instantiating a `StepIndicator` component.
 */
export interface StepIndicatorProps {
  /**
   * Number of steps the component will display
   */
  steps: number;
  /**
   * Number of the step that is currently active
   */
  currentStep?: number;
}

export function StepIndicator({ steps, currentStep = 0 }: StepIndicatorProps) {
  const {t} = useTranslation();

  if (steps <= 0) {
    return <></>;
  }

  let ariaText = t('step_indicator_alt_text', "Step {{currentStep}} of {{totalSteps}}", {
    currentStep: currentStep+1,
    totalSteps: steps
  })

  return (
    <div
      className="step-container"
      role="progressbar"
      aria-valuenow={currentStep}
      aria-valuemax={steps}
      aria-valuetext={ariaText}
    >
      {Array.from({ length: steps }).map((_, index) => (
        <div
          key={index}
          className={`step ${
            currentStep === index
              ? "active"
              : currentStep > index
              ? "visited"
              : ""
          }`}
        ></div>
      ))}
    </div>
  );
}
